import React, { useCallback } from 'react'

import { trackMemberTask } from '../analytics'
import { getMemberTaskDefinition } from '../memberTaskDefinitions'
import type { MemberTaskBarItemModel } from '../types'

export type MemberTaskBarItemProps = {
  task: MemberTaskBarItemModel
}

const MemberTaskBarItem: React.FC<MemberTaskBarItemProps> = ({ task }) => {
  const { Banner } = getMemberTaskDefinition(task.type)

  const handleOnPress = useCallback(() => {
    trackMemberTask('tapped', task.memberTask)
    task.onPress()
  }, [task])

  return (
    <Banner
      memberTask={task.memberTask}
      onPress={handleOnPress}
      testID={`MEMBER_TASK_ITEM_${task.id}`}
    />
  )
}

export default MemberTaskBarItem
